export const MAX_PRICE_RANGE = Infinity;
export const MAX_PRICE_RANGE_PROCESSING = 10_000_000;
